import axiosInstance from './api_helper';

const BASE_URL = '/api/settings/woocommerce';

export const getWooCommerceConfiguration = () =>
    axiosInstance.get(BASE_URL);

export const saveWooCommerceConfiguration = (configuration) =>
    axiosInstance.put(BASE_URL, configuration);

export const testWooCommerceConnection = () =>
    axiosInstance.post(`${BASE_URL}/test`);

export const setWooCommerceSynchronization = (enabled) =>
    axiosInstance.put(`${BASE_URL}/synchronization`, { enabled });

export const synchronizeWooCommerceCategories = () =>
    axiosInstance.post(`${BASE_URL}/categories/synchronize`);

export const getWooCommerceCategorySynchronization = (categoryId) =>
    axiosInstance.get(`${BASE_URL}/categories/${categoryId}/synchronization`);

export const synchronizeWooCommerceCategory = (categoryId) =>
    axiosInstance.post(`${BASE_URL}/categories/${categoryId}/synchronize`);

export const getWooCommerceProductSynchronization = (productId) =>
    axiosInstance.get(`${BASE_URL}/products/${productId}/synchronization`);

export const synchronizeWooCommerceProduct = (productId) =>
    axiosInstance.post(`${BASE_URL}/products/${productId}/synchronize`);

export const startWooCommerceProductSynchronizationJob = () =>
    axiosInstance.post(`${BASE_URL}/products/synchronization-jobs`);

export const getWooCommerceProductSynchronizationJob = (jobId) =>
    axiosInstance.get(`${BASE_URL}/products/synchronization-jobs/${jobId}`);

export const getCurrentWooCommerceProductSynchronizationJob = () =>
    axiosInstance.get(`${BASE_URL}/products/synchronization-jobs/current`);

export const getWooCommerceProductSynchronizationJobErrors = (
    jobId,
    page = 0,
    size = 50
) =>
    axiosInstance.get(
        `${BASE_URL}/products/synchronization-jobs/${jobId}/errors`,
        { params: { page, size } }
    );
